import React from "react";

import "./separator.scss";

/*
 * Main
 */

export const Separator = (): React.ReactElement => {
    return <div className="separator" />;
};
